import { noop } from 'lodash';
import { createContext, PropsWithChildren, useContext, useEffect, useMemo, useState } from 'react';

interface HideFooterContextValue {
  hideFooter: boolean;
  setHideFooter: (value: boolean) => void;
}

const HideFooterContext = createContext<HideFooterContextValue>({
  hideFooter: false,
  setHideFooter: noop,
});

export const HideFooterProvider = ({ children }: PropsWithChildren) => {
  const [hideFooter, setHideFooter] = useState(false);

  const value = useMemo(() => ({ hideFooter, setHideFooter }), [hideFooter]);

  return <HideFooterContext.Provider value={value}>{children}</HideFooterContext.Provider>;
};

export const useHideFooterValue = () => useContext(HideFooterContext).hideFooter;

const useSetHideFooter = () => useContext(HideFooterContext).setHideFooter;

/**
 * Call this hook to dynamically hide the page footer.
 * The footer will be restored when the component unmounts.
 */
export const useHideFooter = () => {
  const setHideFooter = useSetHideFooter();

  useEffect(() => {
    setHideFooter(true);
    return () => setHideFooter(false);
  }, [setHideFooter]);
};
